import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Injectable } from '@angular/core';
import { Core2Config } from '../shared/core2Config';
import { AppLoginContainerModel } from '../../../../../models/aggregates/id';
import { ApiResponseModel } from '../shared/api-response.model';
import { ApiVisa } from '../shared/api-visa.model';
import {
  AddEmailMobileNumberRequest, ChangeEmailMobileNumberRequest,
  IdVerificationForChangeEmailMobileNumberRequest, IdVerificationReqForChangeEmailMobileNumberRequest,
  ResetMobileNumber } from '../shared/login.model';
import { Observable } from 'rxjs';
import { BasicApiResponseModel } from '../shared/api-response.model';
import { AppLoginChangeEmailMobileNumberProcessContainerModel } from '../../../../../models/aggregates/app-login';

@Injectable({ providedIn: 'root' })
export class UserProfileService extends BaseApiTemplateService<AppLoginContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'identity/userprofile';
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'identity/userprofile';
    this.httpClient = http;
  }

  updateImage(formData: FormData, imageGuid, visa: ApiVisa) {
    let url = this.apiUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path;
    }
    console.log(this.apiUrl + 'photo', formData);
    return this.httpClient.put(url + '/photo/replace/' + imageGuid, formData, this.getHttpHeader(visa));
  }

  uploadImage(formData: FormData, subjectGuid, visa: ApiVisa) {
    let url = this.apiUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path;
    }
    console.log(this.apiUrl + 'photo', formData);
    return this.httpClient.post(url + '/photo/' + subjectGuid, formData, this.getHttpHeader(visa));
  }

  getImage(formData: FormData, subjectGuid, visa: ApiVisa) {
    let url = this.apiUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path;
    }
    console.log(this.apiUrl + 'photo', formData);
    return this.httpClient.get(url + '/photo/' + subjectGuid, this.getHttpHeader(visa));
  }

  resetMobileNumber(requestData: ResetMobileNumber, visa: ApiVisa): Promise<ApiResponseModel<any>> {
    let url = this.apiUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/reset-mobile-number';
    }

    return this.httpClient.post<BasicApiResponseModel<any>>(
      url,
      requestData,
      this.getHttpHeader(visa)
    ).toPromise();
  }

  getProfileName(visa: ApiVisa, guid: string): Observable<BasicApiResponseModel<string>> {
    let url = this.apiUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path;
    }
    const Url = url + '/name/' + guid;
    return this.httpClient.get<BasicApiResponseModel<string>>
      (Url, this.getHttpHeader(visa));
  }


  getUserDetail(visa: ApiVisa): Observable<BasicApiResponseModel<any>> {
    let url = this.apiUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<BasicApiResponseModel<any>>(url, this.getHttpHeader(visa));
  }

  // for change-email-mobile-number
  requestExistingIdentityVerificationForChangeEmail(
    requestData: IdVerificationReqForChangeEmailMobileNumberRequest, visa: ApiVisa, tenantCode?: string, websiteCode?: string): Promise<BasicApiResponseModel<AppLoginChangeEmailMobileNumberProcessContainerModel>> {
    let url = this.apiUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/request-existing-identity-verification-for-change-email' + ((visa.AccessID && visa.AccessKey) ? '-access-key' : '');
    }

    if (tenantCode || websiteCode) {
      url = url + '?';
    }
    if (tenantCode) {
      url = url + 'tenantCode=' + tenantCode;
    }
    if (websiteCode) {
      url = url + '&websiteCode=' + websiteCode;
    }

    if (visa.AccessID && visa.AccessKey) {
      return this.httpClient.post<BasicApiResponseModel<any>>(
        url,
        requestData,
        this.getHttpHeaderAccessKey(visa)
      ).toPromise();
    } else {
      return this.httpClient.post<BasicApiResponseModel<any>>(
        url,
        requestData,
        this.getHttpHeader(visa)
      ).toPromise();
    }
  }

  requestExistingIdentityVerificationForChangeMobileNumber(
    requestData: IdVerificationReqForChangeEmailMobileNumberRequest, visa: ApiVisa, tenantCode?: string, websiteCode?: string): Promise<BasicApiResponseModel<AppLoginChangeEmailMobileNumberProcessContainerModel>> {
    let url = this.apiUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/request-existing-identity-verification-for-change-mobile-number' + ((visa.AccessID && visa.AccessKey) ? '-access-key' : '');
    }

    if (tenantCode || websiteCode) {
      url = url + '?';
    }
    if (tenantCode) {
      url = url + 'tenantCode=' + tenantCode;
    }
    if (websiteCode) {
      url = url + '&websiteCode=' + websiteCode;
    }

    if (visa.AccessID && visa.AccessKey) {
      return this.httpClient.post<BasicApiResponseModel<AppLoginChangeEmailMobileNumberProcessContainerModel>>(
        url,
        requestData,
        this.getHttpHeaderAccessKey(visa)
      ).toPromise();
    } else {
      return this.httpClient.post<BasicApiResponseModel<AppLoginChangeEmailMobileNumberProcessContainerModel>>(
        url,
        requestData,
        this.getHttpHeader(visa)
      ).toPromise();
    }
  }

  existingIdentityVerificationForChangeEmailMobileNumber(
    requestData: IdVerificationForChangeEmailMobileNumberRequest, visa: ApiVisa): Promise<BasicApiResponseModel<boolean>> {
    let url = this.apiUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/existing-identity-verification-for-change-email-mobile-number' + ((visa.AccessID && visa.AccessKey) ? '-access-key' : '');
    }

    if (visa.AccessID && visa.AccessKey) {
      return this.httpClient.post<BasicApiResponseModel<boolean>>(
        url,
        requestData,
        this.getHttpHeaderAccessKey(visa)
      ).toPromise();
    } else {
      return this.httpClient.post<BasicApiResponseModel<boolean>>(
        url,
        requestData,
        this.getHttpHeader(visa)
      ).toPromise();
    }
  }

  changeEmail(
    requestData: ChangeEmailMobileNumberRequest, visa: ApiVisa, tenantCode?: string, websiteCode?: string): Promise<BasicApiResponseModel<AppLoginChangeEmailMobileNumberProcessContainerModel>> {
    let url = this.apiUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/change-email' + ((visa.AccessID && visa.AccessKey) ? '-access-key' : '');
    }

    if (tenantCode || websiteCode) {
      url = url + '?';
    }
    if (tenantCode) {
      url = url + 'tenantCode=' + tenantCode;
    }
    if (websiteCode) {
      url = url + '&websiteCode=' + websiteCode;
    }

    if (visa.AccessID && visa.AccessKey) {
      return this.httpClient.post<BasicApiResponseModel<AppLoginChangeEmailMobileNumberProcessContainerModel>>(
        url,
        requestData,
        this.getHttpHeaderAccessKey(visa)
      ).toPromise();
    } else {
      return this.httpClient.post<BasicApiResponseModel<AppLoginChangeEmailMobileNumberProcessContainerModel>>(
        url,
        requestData,
        this.getHttpHeader(visa)
      ).toPromise();
    }
  }

  changeMobileNumber(
    requestData: ChangeEmailMobileNumberRequest, visa: ApiVisa, tenantCode?: string, websiteCode?: string): Promise<BasicApiResponseModel<AppLoginChangeEmailMobileNumberProcessContainerModel>> {
    let url = this.apiUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/change-mobile-number' + ((visa.AccessID && visa.AccessKey) ? '-access-key' : '');
    }

    if (tenantCode || websiteCode) {
      url = url + '?';
    }
    if (tenantCode) {
      url = url + 'tenantCode=' + tenantCode;
    }
    if (websiteCode) {
      url = url + '&websiteCode=' + websiteCode;
    }

    if (visa.AccessID && visa.AccessKey) {
      return this.httpClient.post<BasicApiResponseModel<AppLoginChangeEmailMobileNumberProcessContainerModel>>(
        url,
        requestData,
        this.getHttpHeaderAccessKey(visa)
      ).toPromise();
    } else {
      return this.httpClient.post<BasicApiResponseModel<AppLoginChangeEmailMobileNumberProcessContainerModel>>(
        url,
        requestData,
        this.getHttpHeader(visa)
      ).toPromise();
    }
  }

  newIdentityVerificationForChangeEmailMobileNumber(
    requestData: IdVerificationForChangeEmailMobileNumberRequest, visa: ApiVisa): Promise<BasicApiResponseModel<boolean>> {
    let url = this.apiUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/new-identity-verification-for-change-email-mobile-number' + ((visa.AccessID && visa.AccessKey) ? '-access-key' : '');
    }

    if (visa.AccessID && visa.AccessKey) {
      return this.httpClient.post<BasicApiResponseModel<boolean>>(
        url,
        requestData,
        this.getHttpHeaderAccessKey(visa)
      ).toPromise();
    } else {
      return this.httpClient.post<BasicApiResponseModel<boolean>>(
        url,
        requestData,
        this.getHttpHeader(visa)
      ).toPromise();
    }
  }

  addEmail(
    requestData: AddEmailMobileNumberRequest, visa: ApiVisa, tenantCode?: string, websiteCode?: string): Promise<BasicApiResponseModel<AppLoginChangeEmailMobileNumberProcessContainerModel>> {
    let url = this.apiUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/add-email' + ((visa.AccessID && visa.AccessKey) ? '-access-key' : '');
    }

    if (tenantCode || websiteCode) {
      url = url + '?';
    }
    if (tenantCode) {
      url = url + 'tenantCode=' + tenantCode;
    }
    if (websiteCode) {
      url = url + '&websiteCode=' + websiteCode;
    }

    if (visa.AccessID && visa.AccessKey) {
      return this.httpClient.post<BasicApiResponseModel<AppLoginChangeEmailMobileNumberProcessContainerModel>>(
        url,
        requestData,
        this.getHttpHeaderAccessKey(visa)
      ).toPromise();
    } else {
      return this.httpClient.post<BasicApiResponseModel<AppLoginChangeEmailMobileNumberProcessContainerModel>>(
        url,
        requestData,
        this.getHttpHeader(visa)
      ).toPromise();
    }
  }

  addMobileNumber(
    requestData: AddEmailMobileNumberRequest, visa: ApiVisa, tenantCode?: string, websiteCode?: string): Promise<BasicApiResponseModel<AppLoginChangeEmailMobileNumberProcessContainerModel>> {
    let url = this.apiUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/add-mobile-number' + ((visa.AccessID && visa.AccessKey) ? '-access-key' : '');
    }

    if (tenantCode || websiteCode) {
      url = url + '?';
    }
    if (tenantCode) {
      url = url + 'tenantCode=' + tenantCode;
    }
    if (websiteCode) {
      url = url + '&websiteCode=' + websiteCode;
    }

    if (visa.AccessID && visa.AccessKey) {
      return this.httpClient.post<BasicApiResponseModel<AppLoginChangeEmailMobileNumberProcessContainerModel>>(
        url,
        requestData,
        this.getHttpHeaderAccessKey(visa)
      ).toPromise();
    } else {
      return this.httpClient.post<BasicApiResponseModel<AppLoginChangeEmailMobileNumberProcessContainerModel>>(
        url,
        requestData,
        this.getHttpHeader(visa)
      ).toPromise();
    }
  }

  appRedirectToChangeEmail(
		visa: ApiVisa, tenantCode: string, subjectGuid: string, websiteCode?: string, messageTemplate?: string): Observable<string> {

    let domainAndEndpointPath: string;
    if (this.endpoint_path && visa.api_domain_url) {
      domainAndEndpointPath = visa.api_domain_url + this.endpoint_path;
    } else {
      domainAndEndpointPath = this.apiUrl;
    }

		let url = domainAndEndpointPath + '/app-redirect-to-change-email?' +
		  'tenantCode=' + tenantCode +
		  '&subjectGuid=' + subjectGuid +
		  (websiteCode ? '&websiteCode=' + websiteCode : '') +
		  (messageTemplate ? '&messageTemplate=' + messageTemplate : '');

		return this.httpClient.post<string>(
            url,
            null,
            this.getHttpHeaderText(visa)
          );
	}

  appRedirectToChangeMobileNumber(
		visa: ApiVisa, tenantCode: string, subjectGuid: string, websiteCode?: string, messageTemplate?: string): Observable<string> {

    let domainAndEndpointPath: string;
    if (this.endpoint_path && visa.api_domain_url) {
      domainAndEndpointPath = visa.api_domain_url + this.endpoint_path;
    } else {
      domainAndEndpointPath = this.apiUrl;
    }

		let url = domainAndEndpointPath + '/app-redirect-to-change-mobile-number?' +
		  'tenantCode=' + tenantCode +
		  '&subjectGuid=' + subjectGuid +
		  (websiteCode ? '&websiteCode=' + websiteCode : '') +
		  (messageTemplate ? '&messageTemplate=' + messageTemplate : '');

		return this.httpClient.post<string>(
            url,
            null,
            this.getHttpHeaderText(visa)
          );
	}

  public deleteMultiple(tenantCode: String, dtoObject: any, visa: ApiVisa){
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/delete-custom/' + tenantCode + '/tenant-ep';
    }

    let httpOptions = this.getHttpHeader(visa);
    httpOptions.headers = httpOptions.headers.set("Content-Type", "application/json");

    // Use httpClient.request to send a DELETE request with a body
    return this.httpClient.request('delete', this.apiUrl, {
      ...httpOptions,
      body: dtoObject
    });
  }
}
